import { render, staticRenderFns } from "./SincereGuard.vue?vue&type=template&id=7855120f"
import script from "./SincereGuard.vue?vue&type=script&lang=js"
export * from "./SincereGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports